import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { HttpClient,HttpResponse,  HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ConfigService } from './config.service';

import { Product } from '@app/interfaces'

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  url = '/product'
  private productsSubject: BehaviorSubject<Product[]> = new BehaviorSubject([]);
  public products$: Observable<Product[]> = this.productsSubject.asObservable();
  
  private product: Product = { id: 0, name: '', productType: '', planType: '', sku:'', active: false}
  private productSubject: BehaviorSubject<Product> = new BehaviorSubject(this.product);
  public product$: Observable<Product> = this.productSubject.asObservable();

  constructor(private config: ConfigService) { } 

  public get products(): Product[] {
    return this.productsSubject.value;
  }

  findAll() {
    const products$: Observable<Product[]> = <Observable<Product[]>>this.config.get(this.url)
    products$.subscribe( (value: Product[]) => this.productsSubject.next(value));    
    return products$
  }

  create(body) {
    const product$ = this.config.post(this.url,body)    
    product$.subscribe( (value: Product) => this.productSubject.next(value));    
    return product$
  }

  update(id,body) {
    const product$ = this.config.post(this.url + '/' + id,body)
    product$.subscribe( (value: Product) => this.productSubject.next(value));    
    return product$
  }

}
